import { render, staticRenderFns } from "./modal.component.vue?vue&type=template&id=544a8252&scoped=true"
import script from "./modal.component.vue?vue&type=script&lang=js"
export * from "./modal.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544a8252",
  null
  
)

export default component.exports